var i = /* @__PURE__ */ ((n) => (n.English = "en_us", n.French = "fr", n.Japanese = "ja", n.Korean = "kr", n.Portuguese = "pt_pt", n.Russian = "ru", n.Thai = "th", n.Filipino = "tl", n.Ukrainian = "uk", n.Vietnamese = "vi", n.Chinese_China = "zh_cn", n.Chinese_Taiwan = "zh_tw", n))(i || {});
const r = "en_us";
export {
  r as DEFAULT_LOCALE,
  i as Locale
};
//# sourceMappingURL=locale.js.map
